import { Divider, HStack, useColorMode, VStack } from '@chakra-ui/react'
import { Body, Checkbox, ValidatedInput } from '@missionlabs/react'
import { UserRole } from '@missionlabs/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUserRole } from 'shared/hooks/useUserRole'

interface Props {}

export const CallBarring: React.FC<Props> = () => {
    const { t } = useTranslation()
    const { colorMode } = useColorMode()

    const isAdmin = useUserRole() === UserRole.ADMIN

    return (
        <VStack width="full" spacing="16px" divider={<Divider />}>
            <VStack align="left" width="full">
                <Body size="md" color={`${colorMode}.coolGrey.80`}>
                    {t('admin.users.callBarring.callPermissions')}
                </Body>
                <ValidatedInput name="outboundBarring.international_calling">
                    <Checkbox isDisabled={!isAdmin}>
                        {t('admin.users.callBarring.international')}
                    </Checkbox>
                </ValidatedInput>

                <ValidatedInput name="outboundBarring.premium_calling">
                    <Checkbox isDisabled={!isAdmin}>
                        {t('admin.users.callBarring.premium')}
                    </Checkbox>
                </ValidatedInput>
            </VStack>

            <VStack align="left" width="full">
                <Body size="md" color={`${colorMode}.coolGrey.80`}>
                    {t('admin.users.callBarring.titleCallBarring')}
                </Body>
                <HStack>
                    <ValidatedInput name="inboundBarring.all_calls">
                        <Checkbox isDisabled={!isAdmin}>
                            {t('admin.users.callBarring.inboundCalls')}
                        </Checkbox>
                    </ValidatedInput>
                </HStack>

                <ValidatedInput name="outboundBarring.all_calls">
                    <Checkbox isDisabled={!isAdmin}>
                        {t('admin.users.callBarring.outboundCalls')}
                    </Checkbox>
                </ValidatedInput>
            </VStack>
        </VStack>
    )
}
